<template>
  <v-layout class="font-weight-light caption mt-2" wrap>
    <v-flex>Última actualización:</v-flex>
    <v-flex class="font-italic text-xs-center">{{ dateString }}</v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState } = createNamespacedHelpers("matching");

/**
 * A component that renders the last price update of the item to indicate
 * when it was updated or the range of last price updates of the item's
 * qmp if it has one.
 *
 * If the item does not have the `lastPriceUpdate` value it will show a
 * message indicating that the item does not have any date.
 */
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    /* This flag indicates if the item is the cover page of the qmp and it must show
    the date range or only the item's last price update */
    qmpCoverPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["similarItemsQmps"]),
    /**
     * Get the date string to show
     */
    dateString() {
      const itemDate = this.item.lastPriceUpdate
        ? this.item.lastPriceUpdate.slice(0, 10)
        : "sin fecha";

      if (!this.qmpCoverPage || !this.qmp) {
        return itemDate;
      }

      let minDate = null;
      let maxDate = null;

      this.qmp.items.forEach(({ lastPriceUpdate }) => {
        if (lastPriceUpdate) {
          if (!minDate || lastPriceUpdate < minDate) {
            minDate = lastPriceUpdate;
          }
          if (!maxDate || lastPriceUpdate > maxDate) {
            maxDate = lastPriceUpdate;
          }
        }
      });

      if (minDate && maxDate && minDate !== maxDate) {
        return `${minDate.slice(0, 10)} - ${maxDate.slice(0, 10)}`;
      }

      return itemDate;
    },
    /**
     * Get the QMP associated to this item.
     */
    qmp() {
      return this.similarItemsQmps[this.item.productId];
    }
  }
};
</script>